import React from 'react';
import { Box, Grid, TextField, Typography, FormControlLabel, Checkbox } from '@mui/material';
import SectionHeader from './SectionHeader';

export default function AddressSection({
    title,
    addressType,
    formData,
    handleInputChange,
    hasError,
    getErrorMessage,
    inputStyles,
    redAsteriskStyle,
    showSameAsCheckbox = false
}) {
    const prefix = addressType; // 'present' or 'permanent'

    return (
        <Box>
            <SectionHeader title={title} />
            <Box sx={{ p: 3 }}>
                <Grid container spacing={3}>
                    {showSameAsCheckbox && (
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.sameAsPresentAddress}
                                        onChange={handleInputChange}
                                        name="sameAsPresentAddress"
                                        color="primary"
                                    />
                                }
                                label="Same as Present Address"
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            City <span style={redAsteriskStyle}>*</span>
                        </Typography>
                        <TextField
                            required
                            fullWidth
                            value={formData[`${prefix}City`]}
                            onChange={handleInputChange}
                            id={`${prefix}City`}
                            placeholder="Enter your city"
                            name={`${prefix}City`}
                            variant="outlined"
                            sx={inputStyles}
                            error={hasError(`${prefix}City`)}
                            helperText={getErrorMessage(`${prefix}City`)}
                            disabled={prefix === 'permanent' && formData.sameAsPresentAddress}
                            InputProps={{
                                required: false
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Address
                        </Typography>
                        <TextField
                            fullWidth
                            value={formData[`${prefix}Address`]}
                            onChange={handleInputChange}
                            id={`${prefix}Address`}
                            placeholder="Enter your full address"
                            name={`${prefix}Address`}
                            variant="outlined"
                            sx={inputStyles}
                            disabled={prefix === 'permanent' && formData.sameAsPresentAddress}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Pin Code
                        </Typography>
                        <TextField
                            fullWidth
                            value={formData[`${prefix}Pincode`]}
                            onChange={handleInputChange}
                            id={`${prefix}Pincode`}
                            placeholder="Enter your PIN code"
                            name={`${prefix}Pincode`}
                            variant="outlined"
                            sx={inputStyles}
                            disabled={prefix === 'permanent' && formData.sameAsPresentAddress}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}